import {useGetAllWellsQuery, WellEntity, wellsSelector, WellSelectorProps} from "@ots-frontend/ots-data";
import {BaseWellSelect, BaseWellSelectProps} from "./BaseWellSelect";
import {useMemo, useState} from "react";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type WellSelectProps = Omit<BaseWellSelectProps, "entities" | "loading"> & {
  selector?: WellSelectorProps
}

export const WellSelect = (props: WellSelectProps) => {
  const {selector, ...rest} = props;

  const selectWells = useMemo(() => {
    return wellsSelector();
  }, []);

  const {wells, isLoading} = useGetAllWellsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      wells: selectWells(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseWellSelect entities={wells} loading={isLoading} {...rest} />;
};

export interface WellSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: WellSelectProps,
  onSubmit?: (wells: WellEntity[] | undefined) => void
}

export const WellSelectModal = (props: WellSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedWells, setSelectedWells] = useState<WellEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <WellSelect
          {...select}
          onEntityChange={e => setSelectedWells(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedWells);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
